import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../../components/common/BriaButton/BriaButton.tsx";
import useAdsEditorUtils from "../../../../../hooks/useAdsEditorUtils.tsx";
import useSetIsSidebarOpen from "../../../../../hooks/useSetIsSidebarOpen.tsx";
import styles from "./AdsEmptyState.module.scss";

interface AdsEmptyStateProps {
	isTemplatesAndBrandsMode?: boolean;
}

const AdsEmptyState = ({ isTemplatesAndBrandsMode = false }: AdsEmptyStateProps) => {
	const { t } = useTranslation("translation", {
		keyPrefix: isTemplatesAndBrandsMode
			? "editor.adsEditorV2.templatesAndBrandsEmptyState"
			: "editor.adsEditorV2.emptyState",
	});

	const setIsSidebarOpen = useSetIsSidebarOpen();
	const { openTemplatesTab, openBrandsTab } = useAdsEditorUtils();

	useEffect(() => {
		setIsSidebarOpen(false);
	}, []);

	return (
		<Box className={styles.adsEditorEmptyState}>
			<Typography className={styles.title}>{t("title")}</Typography>
			<Typography
				className={
					!isTemplatesAndBrandsMode ? styles.description1 : styles.templatesAndBrandsEmptyStateDescription1
				}
			>
				{t("description1")}
			</Typography>
			<Typography className={styles.description2}>{t("description2")}</Typography>
			<Box className={styles.buttonsContainer}>
				<BriaButton
					disabled={!isTemplatesAndBrandsMode}
					buttonType="primaryMedium"
					onClick={openTemplatesTab}
					className={clsx(styles.secondaryMedium, styles.btn)}
				>
					{isTemplatesAndBrandsMode ? t("createOrEditATemplate") : t("selectATemplate")}
				</BriaButton>

				<BriaButton
					disabled={!isTemplatesAndBrandsMode}
					buttonType="primaryMedium"
					onClick={openBrandsTab}
					className={clsx(styles.secondaryMedium, styles.btn)}
				>
					{isTemplatesAndBrandsMode ? t("createOrEditYourBrands") : t("SelectABrand")}
				</BriaButton>
			</Box>
		</Box>
	);
};

export default observer(AdsEmptyState);
